<template>
    <main class="container-fluid">
        <div class="row">
            <div class="col-2 bg-white">
                <div class="sidebar-left">
                    <div>
                        <a href="#typography">Tüpograafia</a>
                    </div>
                    <div>
                        <a href="#buttons">Nupud</a>
                    </div>
                    <div>
                        <a href="#example-background-colors">Värvid</a>
                    </div>
                    <div>
                        <a href="#example-text-colors">Teksti värvid</a>
                    </div>
                    <div>
                        <a href="#cards">Kaardid</a>
                    </div>
                    <div>
                        <a href="#borders">Piirid</a>
                    </div>
                    <div>
                        <a href="#modals">Hüpikaknad</a>
                    </div>
                    <div>
                        <a href="#forms">Vormid</a>
                    </div>
                    <div>
                        <a href="#fileuploader">Faili üleslaadimine</a>
                    </div>
                    <div>
                        <a href="#tables">Tabelid</a>
                    </div>
                    <div>
                        <a href="#alerts">Teated</a>
                    </div>
                    <div>
                        <a href="#badges">Märgised</a>
                    </div>
                    <div>
                        <a href="#popovers">Popovers</a>
                    </div>
                    <div>
                        <a href="#pagination">Lehitsemine</a>
                    </div>
                    <div>
                        <a href="#icons">Ikoonid</a>
                    </div>
                    <div>
                        <a href="#loader">Loader</a>
                    </div>
                    <div>
                        <a href="#sidemodal">Sidemodal</a>
                    </div>
                    <div>
                        <a href="#brandbook-style">MIS stiilielemendid</a>
                    </div>
                </div>
            </div>
            <div class="col-10 pl-5 pt-4">
                <!--TEXTS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="typography" class="section-header">
                                Tüpograafia
                            </h2>
                            <a
                                class="anchorjs-link "
                                aria-label="Anchor"
                                data-anchorjs-icon="#"
                                href="#typography"
                                style="padding-left: 0.375em;"
                            ></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <heading-wave>
                                Lainega pealkiri
                            </heading-wave>
                        </div>
                        <div class="col-6">
                            <h1 class="heading">Pealkiri H1</h1>
                            <h2 class="heading">Pealkiri H2</h2>
                            <h3 class="heading">Pealkiri H3</h3>
                            <h4 class="heading">Pealkiri H4</h4>
                            <h5 class="heading">Pealkiri H5</h5>
                            <h6 class="heading">Pealkiri H6</h6>
                            <h6 class="heading-condensed color-primary font-size-lg">Pealkiri</h6>
                            <h6 class="heading-condensed font-size-lg">Pealkiri</h6>
                            <h6 class="heading-light">Pealkiri</h6>
                            <h6 class="heading-light-upper">Pealkiri</h6>
                            <h6 class="heading-condensed-upper">Pealkiri</h6>
                            <h6 class="heading-sm">Pealkiri</h6>

                            <p>Paragrahv</p>

                            <div class="font-size-sm">Font small</div>
                            <div class="font-size-md">Font medium</div>
                            <div class="font-size-lg">Font large</div>
                            <div class="font-size-xl">Font large</div>

                            <div class="certificate-name">Pädevustunnistuse nimi</div>
                            <div class="certificate-legal-name">
                                Pädevustunnistuse juriidiline nimi
                            </div>
                        </div>
                        <div class="col-6">
                            <ul>
                                <li>Nimekirja element</li>
                                <li>Nimekirja element</li>
                                <li>
                                    <ul>
                                        <li>Nimekirja element</li>
                                        <li>Nimekirja element</li>
                                    </ul>
                                </li>
                            </ul>
                            <div class="label-group">
                                <div class="label">Välja pealkiri</div>
                                <div class="content">Välja sisu</div>
                            </div>
                            <div class="label-group label-group-sm">
                                <div class="label">Välja pealkiri</div>
                                <div class="content">Välja sisu</div>
                            </div>
                            <div class="heading-sm">Sektsiooni pealkiri</div>
                            <heading-group divider>
                                <template #heading>
                                    Sektsiooni pealkiri joone ja nupuga
                                </template>
                                <template #actions>
                                    <b-button size="sm" variant="secondary" class="btn-wide">
                                        <i
                                            class="fas fa-sync mr-2 color-primary"
                                            aria-hidden="true"
                                        ></i>
                                        Secondary
                                    </b-button>
                                </template>
                            </heading-group>
                            <heading-group divider>
                                <template #heading>
                                    Sektsiooni pealkiri joonega
                                </template>
                            </heading-group>
                            <heading-group>
                                <template #heading>
                                    Sektsiooni pealkiri nupuga
                                </template>
                                <template #actions>
                                    <b-button size="sm" variant="secondary">
                                        <i
                                            class="fas fa-sync mr-2 color-primary"
                                            aria-hidden="true"
                                        ></i>
                                        Secondary
                                    </b-button>
                                </template>
                            </heading-group>
                        </div>
                    </div>
                </section>

                <!--BUTTONS-->
                <section class="section example-buttons">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="buttons" class="section-header">Nupud</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="primary" class="btn-wide">Primary</b-button>
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Primaarne nupp - kasutatakse enamasti vormi täitmisel andmete
                                salvestamisel. Asub vaate allosas. Nt: Praktika andmete salvestamine
                                ja lisamine, tervisetõendi salvestamine ja lisamine jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="primary" class="btn-wide" size="sm"
                                >Primary</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Primaarne nupp, väike - kasutatakse enamasti hüpikaknas, lehe päises
                                ning sisus. Asub vaate päises või sisus. Nt: Uue kvalifikatsiooni
                                lisamine, uue praktika lisamine, praktika aja lisamine jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="secondary" class="btn-wide">Secondary</b-button>
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Sekundaarne nupp - kasutatakse enamasti vaate sisus kus nupp ei oma
                                põhitoimingu rolli. Asub lehe sisus. Nt: Menetluse üle võtmine jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="secondary" class="btn-wide" size="sm"
                                >Secondary</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Sekundaarne nupp, väike - kasutatakse enamasti vaate sisus kus nupp
                                ei oma põhitoimingu rolli. Näiteks: allalaadimine, andmete muutmine
                                jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="outline-secondary" class="btn-wide"
                                >Outline secondary</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Sekundaarne nupp, piirjoontega - kasutatakse enamasti vaate sisus
                                kus nupp on lisatud navigeerimise eesmärgil. Näiteks: 'Tagasi' nupp
                                taotluse sees.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="outline-secondary" class="btn-wide" size="sm"
                                >Outline secondary</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Sekundaarne nupp, piirjoontega, väike - kasutatakse sulgemiseks või
                                navigeerimise eesmärgil. Näiteks: Hüpikaknas 'Loobu' nupp.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="success" class="btn-wide">Success</b-button>
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Primaarse alternatiiv nupp - kasutatakse esile tõstetmise eesmärgil
                                et suunata kasutaja läbi mingi protsessi või eristada
                                positiivset/negatiivset valikut. Nt: Taotluse esitamine, Dokumendi
                                väljastamine.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="success" class="btn-wide" size="sm"
                                >Success</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Primaarse alternatiiv nupp, väike - kasutatakse esile tõstetmise
                                eesmärgil et suunata kasutaja läbi mingi protsessi või eristada
                                positiivset/negatiivset valikut. Väike nupp on kasutusel vaate sisus
                                või hüpikaknas. Nt: Taotluse nõude aktsepteerimine, Dokumendi
                                väljastamise kinnitus, Dokumendi oleku kehtivaks märkimine.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="outline-danger" class="btn-wide"
                                >Outline danger</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Negatiivse toimingu nupp - omab negatiivset tagajärge, asub vaate
                                sisus. Nt: Taotluse tagasilükkamine, nõude tagasilükkamine,
                                riigilõivu makse tühistamine jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="outline-danger" class="btn-wide" size="sm"
                                >Outline danger</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Negatiivse toimingu nupp, piirjoontega - omab negatiivset tagajärge,
                                asub vaate sisus. Nt: Taotluse nõude tagasi lükkamine, andmete
                                eemaldamine/kustutamine.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="danger" class="btn-wide" size="sm">Danger</b-button>
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Negatiivse toimingu nupp, väike - omab negatiivset tagajärge, asub
                                hüpikaknas. Nt: Taotluse nõude tagasi lükkamise modaal, Taotluse
                                tagasi lükkamise hüpikaken jne.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="outline-warning" class="btn-wide" size="sm"
                                >Outline warning</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Hoiatav nupp - Kasutusel dokumendi ajutiselt peatamisel.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-auto">
                            <b-button variant="warning" class="btn-wide" size="sm"
                                >Warning</b-button
                            >
                        </div>
                        <div class="col-md my-auto">
                            <p>
                                Hoiatav nupp, väike - Kasutusel dokumendi ajutiselt peatamise
                                modaalis.
                            </p>
                        </div>
                    </div>

                    <div class="row mt-5">
                        <div class="col-auto">
                            <filter-checkbox v-model="checked1">Button Checkbox sm</filter-checkbox>
                            <filter-checkbox v-model="checked2">Button Checkbox sm</filter-checkbox>
                        </div>
                        <div class="col-auto">
                            <popover-info>
                                Info button text
                            </popover-info>
                        </div>
                    </div>
                </section>

                <!--BACKGROUND COLORS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="example-background-colors" class="section-header">
                                Värvid
                            </h2>
                        </div>
                    </div>
                    <div class="row example-colors">
                        <div class="col-lg-2">
                            <div class="bg-primary">Primary</div>
                            <div class="bg-primary-light">Primary-light</div>
                            <div class="bg-secondary">Secondary</div>
                            <div class="bg-dark">Dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="bg-success">Success</div>
                            <div class="bg-success-light">Success light</div>
                            <div class="bg-success-dark">Success dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="bg-danger">Danger</div>
                            <div class="bg-danger-light">Danger light</div>
                            <div class="bg-danger-dark">Danger dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="bg-warning">Warning</div>
                            <div class="bg-warning-light">Warning light</div>
                            <div class="bg-warning-dark">Warning dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="bg-gray-100">Gray 100</div>
                            <div class="bg-gray-200">Gray 200</div>
                            <div class="bg-gray-300">Gray 300</div>
                            <div class="bg-gray-400">Gray 400</div>
                            <div class="bg-gray-500">Gray 500</div>
                            <div class="bg-gray-600">Gray 600</div>
                            <div class="bg-gray-700">Gray 700</div>
                            <div class="bg-gray-800">Gray 800</div>
                            <div class="bg-gray-900">Gray 900</div>
                        </div>
                    </div>
                </section>

                <!--TEXT COLORS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="example-text-colors" class="section-header">
                                Teksti värvid
                            </h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="color-primary">Primary</div>
                            <div class="color-blue-light">Primary-light</div>
                            <div class="color-dark">Dark</div>
                            <div class="color-black">Black</div>
                            <div class="color-white">White</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="color-green">Success</div>
                            <div class="color-green-light">Success light</div>
                            <div class="color-green-dark">Success dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="color-red">Danger</div>
                            <div class="color-red-light">Danger light</div>
                            <div class="color-red-dark">Danger dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="color-orange">Warning</div>
                            <div class="color-orange-light">Warning light</div>
                            <div class="color-orange-dark">Warning dark</div>
                        </div>
                        <div class="col-lg-2">
                            <div class="color-gray-100">Gray 100</div>
                            <div class="color-gray-200">Gray 200</div>
                            <div class="color-gray-300">Gray 300</div>
                            <div class="color-gray-400">Gray 400</div>
                            <div class="color-gray-500">Gray 500</div>
                            <div class="color-gray-600">Gray 600</div>
                            <div class="color-gray-700">Gray 700</div>
                            <div class="color-gray-800">Gray 800</div>
                            <div class="color-gray-900">Gray 900</div>
                        </div>
                    </div>
                </section>

                <!--CARDS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="cards" class="section-header">Kaardid</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <card-quicklink>
                                <template #icon>
                                    <i
                                        class="fas fa-graduation-cap icon-card"
                                        aria-hidden="true"
                                    ></i>
                                </template>
                                <template #name>
                                    Tasemeõpe
                                </template>
                                <template #description>
                                    Kutse- ja kõrgharidus
                                </template>
                            </card-quicklink>
                        </div>
                        <div class="col-sm-6">
                            <div class="heading-sm">Kaardi pealkiri</div>
                            <div class="card-border">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="label-group">
                                            <div class="label">
                                                Välja pealkiri
                                            </div>
                                            <div class="content">
                                                Välja sisu
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="label-group">
                                            <div class="label">
                                                Välja pealkiri
                                            </div>
                                            <div class="content">
                                                Välja sisu
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="label-group">
                                            <div class="label">
                                                Välja pealkiri
                                            </div>
                                            <div class="content">
                                                Välja sisu
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="label-group">
                                            <div class="label">
                                                Välja pealkiri
                                            </div>
                                            <div class="content">
                                                Välja sisu
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!--BORDERS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="borders" class="section-header">Piirid</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="border mb-2">Border</div>
                            <div class="border-width-md mb-2">Border-md</div>
                            <div class="border-width-lg mb-2">Border-lg</div>
                        </div>
                    </div>
                </section>

                <!--MODALS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="modals" class="section-header">Hüpikaknad</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <!-- Button trigger modal -->
                            <b-button v-b-modal.bmodal variant="primary">Näidis hüpikaken</b-button>

                            <!-- Modal -->
                            <b-modal
                                ref="modal"
                                size="lg"
                                title="Pealkiri"
                                id="bmodal"
                                title-tag="h2"
                            >
                                Siin on sisu
                                <template v-slot:modal-footer>
                                    <b-button variant="outline-secondary" size="sm" @click="cancel">
                                        {{ $ls.Global_Button_Cancel }}
                                    </b-button>
                                    <b-button variant="primary" size="sm">
                                        Salvesta
                                    </b-button>
                                </template>
                            </b-modal>
                        </div>
                    </div>
                </section>

                <!--FORMS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="forms" class="section-header">Vormid</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <form>
                                <div class="form-row">
                                    <div class="col form-group">
                                        <label for="email">E-post</label>
                                        <b-form-input
                                            id="email"
                                            v-model="name"
                                            :state="false"
                                            type="email"
                                            aria-describedby="input-live-help input-live-feedback"
                                            placeholder="E-post"
                                            trim
                                        ></b-form-input>
                                        <small id="emailHelp" class="form-text text-muted">
                                            E-post peab sisaldama '@' sümbolit.
                                        </small>
                                    </div>
                                    <div class="col form-group">
                                        <label for="password">Salasõna</label>
                                        <b-form-input
                                            id="password"
                                            v-model="name2"
                                            type="password"
                                            aria-describedby="input-live-help input-live-feedback"
                                            placeholder="Salasõna"
                                            trim
                                        ></b-form-input>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col form-group">
                                        <label for="role">Roll</label>
                                        <b-form-select
                                            v-model="selected"
                                            :options="options"
                                        ></b-form-select>
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col form-group">
                                        <label for="username">
                                            Kasutajanimi
                                            <label-optional></label-optional>
                                        </label>
                                        <b-form-input
                                            id="username"
                                            v-model="username"
                                            type="text"
                                            aria-describedby="input-live-help input-live-feedback"
                                            placeholder="Kasutajanimi"
                                            trim
                                        ></b-form-input>
                                        <b-form-invalid-feedback>
                                            Enter at least 3 letters
                                        </b-form-invalid-feedback>
                                    </div>
                                </div>
                                <datepicker
                                    labelText="Väljastamise kuupäev"
                                    id="datepicker-date-issued"
                                ></datepicker>
                                <button type="submit" class="btn btn-wide btn-primary float-right">
                                    Salvesta
                                </button>
                            </form>
                        </div>
                        <div class="col-6">
                            <div class="label-group">
                                <div class="label" for="checkbox-example">Checkbox label</div>
                            </div>
                            <b-form-checkbox
                                id="checkbox-example"
                                v-model="checked3"
                                name="checkbox-example"
                                value="accepted"
                                unchecked-value="not_accepted"
                            >
                                Check this custom checkbox
                            </b-form-checkbox>
                            <div class="my-3"></div>
                            <b-form-group label="Individual radios">
                                <b-form-radio v-model="selected" name="some-radios" value="A"
                                    >Valik 1</b-form-radio
                                >
                                <b-form-radio v-model="selected" name="some-radios" value="B"
                                    >Valik 2</b-form-radio
                                >
                            </b-form-group>
                            <div class="row mb-4">
                                <div class="col-md-6">
                                    <b-form-radio
                                        name="with-practice-certificate"
                                        value="false"
                                        class="custom-radio-card"
                                    >
                                        <span class="text-card-primary">{{
                                            $ls.Documents_Practices_Form_Option_PracticeCertificateWithoutFile
                                        }}</span>
                                        <span class="text-card-secondary">{{
                                            $ls.Documents_Practices_Form_Option_MentorConfirmsPractice
                                        }}</span>
                                    </b-form-radio>
                                </div>
                                <div class="col-md-6">
                                    <b-form-radio
                                        name="with-practice-certificate"
                                        value="true"
                                        class="custom-radio-card"
                                    >
                                        <span class="text-card-primary">{{
                                            $ls.Documents_Practices_Form_Option_PracticeCertificateWithFile
                                        }}</span>
                                        <span class="text-card-secondary">{{
                                            $ls.Documents_Practices_Form_Option_OfficialConfirmsPractice
                                        }}</span>
                                    </b-form-radio>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 mt-5">
                            <b-input-group class="input-group-dropdown">
                                <b-form-input placeholder="Otsi" size="lg"></b-form-input>
                                <i class="fas fa-search input-search-icon" aria-hidden="true"></i>
                                <template v-slot:append>
                                    <b-dropdown text="Dokumendi liik" variant="outline-secondary">
                                        <b-dropdown-item>Merelaev</b-dropdown-item>
                                        <b-dropdown-item>Siseveelaev</b-dropdown-item>
                                        <b-dropdown-item>Baasõpe</b-dropdown-item>
                                        <b-dropdown-item>Soodustusluba</b-dropdown-item>
                                        <b-dropdown-item>Lootsi kutsetunnistus</b-dropdown-item>
                                        <b-dropdown-item>Lootsitasõiduluba</b-dropdown-item>
                                        <b-dropdown-item>VTS tunnistus</b-dropdown-item>
                                    </b-dropdown>
                                </template>
                            </b-input-group>
                            <br />
                            <div class="input-group-search">
                                <b-form-input placeholder="Otsi" size="lg"> </b-form-input>
                                <i class="fas fa-search input-search-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="col-6 mt-5">
                            <checkbox-input
                                :checked.sync="checkboxInput.checked"
                                :checkbox-label="checkboxInput.checkboxLabel"
                                :checkbox-name="checkboxInput.checkboxName"
                                :input-value="checkboxInput.inputValue"
                                :input-label="checkboxInput.inputLabel"
                                :input-name="checkboxInput.inputName"
                                :input-placeholder="checkboxInput.inputPlaceholder"
                            ></checkbox-input>
                        </div>
                        <div class="col-6 mt-3">
                            <div class="input-group input-group-multiselect">
                                <label>Komisjoni liikmed</label>
                                <multiselect
                                    class="multiselect-list--bottom"
                                    :block-keys="['Delete']"
                                    :hide-selected="true"
                                    :multiple="true"
                                    :options="multiselect.options"
                                    :show-labels="false"
                                    :taggable="true"
                                    @tag="addTag"
                                    label="name"
                                    placeholder="Otsi või vali"
                                    track-by="name"
                                    v-model="multiselect.value"
                                ></multiselect>
                                <div class="multiselect-tags">
                                    <div
                                        class="multiselect-tag"
                                        v-on:click="removeSelectedValue(multiselect.value)"
                                        v-for="value in multiselect.value"
                                        :key="value.code"
                                    >
                                        {{ value.name
                                        }}<i class="fas fa-times icon" aria-label="Eemalda"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- UPLOADER -->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="fileuploader" class="section-header">
                                Faili üleslaadimine
                            </h2>
                        </div>
                        <div class="col-12">
                            <file-uploader v-model="uploadedFiles"></file-uploader>
                            <div class="file-uploader-uploaded-list">
                                <div class="heading-sm">
                                    Üleslaetud failid
                                </div>
                                <b-table
                                    stacked="md"
                                    :items="uploadedFiles"
                                    :fields="uploadedFileFields"
                                    responsive
                                >
                                    <template v-slot:cell(actions)="">
                                        <b-button
                                            variant="outline-danger"
                                            size="sm"
                                            class="btn-wide-sm float-right"
                                        >
                                            <i class="fas fa-times mr-2 color-red-dark"></i>
                                            Eemalda
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </section>

                <!--TABLES-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="tables" class="section-header">Tabelid</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <b-table
                                sort-icon-left
                                hover
                                :items="items"
                                :fields="fields"
                                responsive
                                @row-clicked="goToMedicalCertificate()"
                            >
                                <template v-slot:cell(state)="data">
                                    <span class="badge badge-success"> {{ data.item.state }}</span>
                                </template>
                                <template v-slot:cell(linkIcon)>
                                    <i class="fas fa-chevron-right" aria-hidden="true"></i>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </section>

                <!--ALERTS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="alerts" class="section-header">Teated</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-alert variant="success" show>
                                <h5 class="alert-heading">Teade õnnestunud</h5>
                                <p>
                                    Teate sisu mis on pikem kui see tekst mis on oma pikkuselt päris
                                    pikk.
                                </p>
                            </b-alert>
                            <b-alert variant="danger" show>
                                <h5 class="alert-heading">Teade viga</h5>
                                <p>
                                    Teate sisu mis on pikem kui see tekst mis on oma pikkuselt päris
                                    pikk.
                                </p>
                            </b-alert>
                            <b-alert variant="warning" show>
                                <h5 class="alert-heading">Teade hoiatus</h5>
                                <p>
                                    Teate sisu mis on pikem kui see tekst mis on oma pikkuselt päris
                                    pikk.
                                </p>
                            </b-alert>
                            <b-alert variant="info" show>
                                <h5 class="alert-heading">
                                    Teade informatiivne
                                </h5>
                                <p>
                                    Teate sisu mis on pikem kui see tekst mis on oma pikkuselt päris
                                    pikk.
                                </p>
                            </b-alert>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-alert variant="info" show dismissible>
                                <h5 class="alert-heading">Teade viga</h5>
                                <p>
                                    Teate sisu mis on pikem kui see tekst mis on oma pikkuselt päris
                                    pikk.
                                </p>
                            </b-alert>
                        </div>
                    </div>
                </section>

                <!--BADGES-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="badges" class="section-header">Märgised</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <h6>Taotluse olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-secondary">Esitamata</span>
                                <span class="badge badge-warning">Esitatud</span>
                                <span class="badge badge-primary">Menetluses</span>
                                <span class="badge badge-success">Dokument väljastatud</span>
                                <span class="badge badge-danger">Tagasi lükatud</span>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <h6>Taotluse nõude olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-success">Aktsepteeritud</span>
                                <span class="badge badge-danger">Tagasi lükatud</span>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <h6>Pädevustunnistuse ja kinnituslehe olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-success">Kehtiv</span>
                                <span class="badge badge-danger">Kehtetu</span>
                                <span class="badge badge-warning">Ajutiselt peatatud</span>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <h6>Meremehe alusdokumentide olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-success">Kehtiv</span>
                                <span class="badge badge-danger">Kehtetu</span>
                                <span class="badge badge-secondary">Kontrollimata</span>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <h6>Protokolli olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-success">Esitatud</span>
                                <span class="badge badge-secondary">Esitamata</span>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <h6>Meremehe profiili olek</h6>
                            <div class="d-inline-flex flex-column">
                                <span class="badge badge-success">Tuvastatud</span>
                                <span class="badge badge-danger">Tuvastamata</span>
                            </div>
                        </div>
                    </div>
                </section>

                <!--POPOVERS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="popovers" class="section-header">
                                Popovers
                            </h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-button :id="`popover-example`" variant="info" class="ml-2">
                                <i class="fas fa-info-circle" aria-hidden="true"></i>
                            </b-button>
                            <b-popover
                                :target="`popover-example`"
                                placement="top"
                                triggers="hover focus"
                                >Info tekst</b-popover
                            >
                        </div>
                    </div>
                </section>

                <!--PAGINATION-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="pagination" class="section-header">
                                Lehitsemine
                            </h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-pagination v-model="currentPage" :total-rows="rows"></b-pagination>
                        </div>
                    </div>
                </section>

                <!--ICONS-->
                <section class="section section-icons">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="icons" class="section-header">Ikoonid</h2>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <i class="fas fa-print" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-ship" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-dharmachakra" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-binoculars" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-graduation-cap" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-file-upload" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-info-circle" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-plus-circle" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-clock" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-file-invoice" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-receipt" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-file-import" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-edit" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="far fa-file-pdf" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-spell-check" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-chalkboard-teacher" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-history" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-sync" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-link" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-file-contract" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-plus" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-wrench" aria-hidden="true"></i>
                        </div>
                        <div class="col">
                            <i class="fas fa-times" aria-hidden="true"></i>
                        </div>
                    </div>
                </section>

                <!-- LOADER -->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="loader" class="section-header">Loader</h2>
                        </div>
                    </div>
                    <!-- Property 'text' adds text, property 'backdrop' adds backdrop. -->
                    <loading-spinner text="Laadimine"></loading-spinner>
                </section>

                <!--MIS STYLE ELEMENTS-->
                <section class="section">
                    <div class="row">
                        <div class="col-12">
                            <h2 id="brandbook-style" class="section-header">
                                MIS stiilielemendid
                            </h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <h5>Lained</h5>
                        </div>
                        <div class="col-sm-4">
                            <img
                                src="@/assets/images-brand/laine-helesinine.svg"
                                alt="Laine helesinine"
                                aria-hidden="true"
                            />
                        </div>
                        <div class="col-sm-4">
                            <img
                                src="@/assets/images-brand/laine-sinine.svg"
                                alt="Laine sinine"
                                aria-hidden="true"
                            />
                        </div>
                        <div class="col-sm-4">
                            <img
                                src="@/assets/images-brand/laine-kollane.svg"
                                alt="Laine kollane"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 my-3">
                            <h5>Logod</h5>
                        </div>
                        <div class="col-sm-3 bg-primary">
                            <img
                                src="@/assets/logos/Transpordiamet_logo_valge_est.svg"
                                alt="MIS logo sinine"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_logo_valge_eng.svg"
                                alt="MIS logo sinine"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_vapp_valge_est.svg"
                                alt="MIS logo"
                            />
                        </div>
                        <div class="col-sm-3">
                            <img
                                src="@/assets/logos/Transpordiamet_logo_must_est.svg"
                                alt="MIS logo sinine"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_logo_must_eng.svg"
                                alt="MIS logo sinine"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_vapp_must_est.svg"
                                alt="MIS logo"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_vapp_must_eng.svg"
                                alt="MIS logo"
                            />
                        </div>
                        <div class="col-sm-3">
                            <img
                                src="@/assets/logos/Transpordiamet_logo_sinine_est.svg"
                                alt="MIS logo sinine"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_logo_sinine_eng.svg"
                                alt="MIS logo sinine"
                            />
                        </div>
                        <div class="col-sm-3">
                            <img
                                src="@/assets/logos/Transpordiamet_vapp_varviline_est.svg"
                                alt="MIS logo"
                            />
                            <img
                                src="@/assets/logos/Transpordiamet_vapp_varviline_eng.svg"
                                alt="MIS logo"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 my-3">
                            <h5>V sümboolika</h5>
                        </div>
                        <div class="col-sm-4">
                            <img
                                src="@/assets/images-brand/v-sumbol-topelt-varviline.svg"
                                alt="MIS sümbol V värviline"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 my-3">
                            <h5>Pildid</h5>
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/paat.jpg"
                                alt="Paat"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/paat_paberist.jpg"
                                alt="Paberist paat"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/purjekas.jpg"
                                alt="Purjekas"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/tuletorn.jpg"
                                alt="Tuletorn"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/tuletorn_inimene.jpg"
                                alt="Tuletorn ja inimene"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/images-brand/tuletorn_kaugelt.jpg"
                                alt="tuletorn"
                                class="img-fluid"
                            />
                        </div>
                        <div class="col-lg-2">
                            <img
                                src="@/assets/logos/emkf-2014-2020-est-el-v-150.jpg"
                                alt="Euroopa Merendus- ja Kalandusfond (EMKF) 2014–2020"
                            />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </main>
</template>

<script>
    import CheckboxInput from "@/features/shared/components/CheckboxInput.vue";
    import Multiselect from "vue-multiselect";
    import FileUploader from "@/components/FileUploader.vue";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
    import PopoverInfo from "@/components/PopoverInfo.vue";
    import FilterCheckbox from "@/components/FilterCheckbox.vue";
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";

    export default {
        name: "StyleGuide",
        components: {
            FileUploader,
            CheckboxInput,
            Multiselect,
            LoadingSpinner,
            HeadingWave,
            HeadingGroup,
            PopoverInfo,
            FilterCheckbox,
            CardQuicklink,
            LabelOptional,
        },
        data() {
            return {
                rows: 100,
                multiselect: {
                    value: [
                        //{ name: 'Kalle Jürisalu', code: '11' }
                    ],
                    options: [
                        { name: "Kalle Jürisalu", code: "11" },
                        { name: "Malle Maasikas", code: "22" },
                        { name: "Jüri Kaasik", code: "33" },
                    ],
                },
                username: "",
                selected: null,
                options: [
                    { value: null, text: "Esimene valik" },
                    { value: "a", text: "Teine valik" },
                    { value: { C: "3PO" }, text: "Kolmas valik" },
                    { value: "d", text: "Ebaaktiivne valik", disabled: true },
                ],
                checked1: false,
                checked2: false,
                checked3: false,
                checkboxInput: {
                    checked: false,
                    checkboxLabel: "Pealkiri checkbox",
                    checkboxName: "checkbox-1",
                    inputValue: "",
                    inputLabel: "Pealkiri input",
                    inputName: "input-1",
                    inputPlaceholder: "input placeholder",
                },
                fields: [
                    {
                        key: "medicalInstitution",
                        label: "Raviasutus",
                        sortable: true,
                    },
                    {
                        key: "doctor",
                        label: "Arst",
                        sortable: true,
                    },
                    {
                        key: "profession",
                        label: "Amet",
                        sortable: true,
                    },
                    {
                        key: "dateGivenOut",
                        label: "Välja antud",
                        sortable: true,
                    },
                    {
                        key: "dateValidUntil",
                        label: "Kehtiv kuni",
                        sortable: true,
                    },
                    {
                        key: "state",
                        label: "Olek",
                        sortable: true,
                    },
                    {
                        key: "linkIcon",
                        label: "",
                        sortable: false,
                        tdClass: "table-actions",
                    },
                ],
                items: [
                    {
                        isActive: true,
                        medicalInstitution: "Clinical",
                        doctor: "Mart Meri",
                        profession: "Kapten",
                        dateGivenOut: "10.10.2020",
                        dateValidUntil: "10.10.2025",
                        state: "Kehtiv",
                    },
                ],
                uploadedFileFields: [
                    {
                        key: "fileName",
                        label: "File Name",
                        sortable: false,
                    },
                    {
                        key: "actions",
                        label: "",
                        headerTitle: "actions",
                        sortable: false,
                        tdClass: "table-actions",
                    },
                ],
                uploadedFiles: [],
            };
        },
        methods: {
            addTag(newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
                };
                this.multiselect.options.push(tag);
                this.multiselect.value.push(tag);
            },
            removeSelectedValue: function(value) {
                const i = this.multiselect.value
                    .map(function(item) {
                        return item.value;
                    })
                    .indexOf(value);
                this.selectedDirective.splice(i, 1);
            },
        },
        computed: {
            nameState() {
                return this.username.length > 2 ? true : false;
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
    @import "@/sass/pages/_styleGuide.scss";
</style>
